import { Fragment } from "react";
import KAURLList from "./KAURLList";
import { useKeywordAssist } from "../Providers/KAProviders";

import KAPrimaryKeywordCard from "./KAPrimaryKeywordCard";
import KATextAnalysisCard from "./KATextAnalysisCard";
import KAKeywordSuggestionsCard from "./KAKeywordSuggestionsCard";
import KAPageTagsAudit from "./KAPageTagsAudit";
import KAAIOptimizationChecklist from "./KAAIOptimizationChecklist";
import { KeywordAssistApiResponse, KeywordAssistPageDetail } from "../../types/keyword-assist.type";


// Mock dynamic data generator based on selected URL utilizing user's exact JSON format
export const getMetadataForURL = (url: string, keywordsData: KeywordAssistApiResponse): KeywordAssistPageDetail | null => {
    if (!url || !keywordsData?.page_details) return null;
    const normalizedUrl = url.toLowerCase();
    const meta = keywordsData.page_details.find(item => item.page_url?.toLowerCase() === normalizedUrl);
    return meta || null;
};

function KADetailedView() {
    const { state: { detailedViewURL, keywordsData } } = useKeywordAssist();
    const meta = getMetadataForURL(detailedViewURL, keywordsData);

    return (
        <Fragment>
            <div className="mt-6" aria-label="url-list" >
                <KAURLList />
            </div>

            {/* Row 1: Metrics & Keywords Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4 items-stretch" aria-label="keyword-assist-current-metadata">
                <KAPrimaryKeywordCard meta={meta} />
                <KATextAnalysisCard meta={meta} />
                <KAKeywordSuggestionsCard meta={meta} />
            </div>

            {/* Row 2: Page Auditor & Actionable checklist UI for Additional Data */}
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 mt-4 items-stretch pb-6">
                <div className="lg:col-span-5">
                    <KAPageTagsAudit meta={meta} />
                </div>
                <div className="lg:col-span-7">
                    <KAAIOptimizationChecklist meta={meta} />
                </div>
            </div>
        </Fragment>
    );
}

export default KADetailedView;